import { render, staticRenderFns } from "./ScreenResult.vue?vue&type=template&id=168871f9"
import script from "./ScreenResult.vue?vue&type=script&lang=js"
export * from "./ScreenResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports